<template>
    <CollapsibleWidget v-if="masterTemplatesLibraryStore.getTemplateFamilies.length > 0">
        <template #name>Master Template Families</template>

        <template #controls />

        <CheckboxGroup v-model="masterTemplatesLibraryStore.families" class="editable-group__values" :vertical="true">
            <Checkbox
                v-for="option in masterTemplatesLibraryStore.getTemplateFamilies"
                :key="option.value"
                :label="option.value"
                :disabled="isFamilyDisabled(option.value)"
            >
                {{ option.label }}
            </Checkbox>
        </CheckboxGroup>
    </CollapsibleWidget>
</template>

<script lang="ts" setup>
import CollapsibleWidget from "@/components/Campaign/widgets/CollapsibleWidget.vue";
import { useMasterTemplatesLibraryStore } from "@/store/pinia/masterTemplatesLibrary";

const masterTemplatesLibraryStore = useMasterTemplatesLibraryStore();

const { isUsedInCampaign } = defineProps<{
    isUsedInCampaign?: boolean;
}>();

function isFamilyDisabled(familyId: string): boolean {
    if (!isUsedInCampaign) {
        return false;
    }

    const matchingFamilyIds = masterTemplatesLibraryStore.getTemplateFamilyIdsMatchingType;

    if (!matchingFamilyIds) {
        return false;
    }

    return !matchingFamilyIds.has(familyId);
}
</script>

<style lang="scss">
.editable-group {
    &__add {
        width: 100%;
    }

    &__values {
        width: 100%;
    }

    .show-form {
        &--showing {
            display: none;
        }
    }
}
</style>
